import React from 'react'
import { useAuth } from 'web/src/auth/useAuth'
import { useWizard } from '@mote/ui'
import { SingleAnswer, Step } from '../../components'
import { useOnboarding } from '../../context'

const ROLES = {
  key: 'role',
  trackingKey: 'role (all users)',
  question: 'I am a...',
  choices: [
    { advanceTo: 'student', icon: '🎒', text: 'Student', value: 'student' },
    { advanceTo: 'educator', icon: '🍏', text: 'Educator', value: 'educator' },
    {
      advanceTo: 'administrator',
      icon: '🏫',
      text: 'Administrator',
      value: 'administrator'
    },
    { advanceTo: 'other', icon: '💼', text: 'Other', value: 'other' }
  ]
}

export const Roles = ({ index, updateSteps }) => {
  const { user } = useAuth()
  const { currentStep, goToNextStep } = useWizard()
  const { state, resetState, updateProperties } = useOnboarding()
  const isActiveStep = React.useMemo(
    () => index === currentStep,
    [currentStep, index]
  )
  const [isMounted, setIsMounted] = React.useState(false)

  const NEW_ROLES = React.useMemo(() => {
    const roles = { ...ROLES }

    if (user?.isInstitutional) roles.choices = roles.choices.slice(0, -1)

    if (user?.isMinor) roles.choices = roles.choices.slice(0, 1)

    return roles
  }, [user])

  React.useEffect(() => {
    if (isMounted) return

    setIsMounted(true)
  }, [])

  React.useEffect(() => {
    if (!state.role) return

    if (state.role !== 'student') {
      updateProperties({ payload: { isMinor: false } }).catch(console.error)
    }

    updateSteps?.(state.role)
    goToNextStep()
  }, [state.role])

  React.useEffect(() => {
    if (!isMounted || !isActiveStep || (isActiveStep && !state.role)) return

    resetState()
    updateSteps?.()
  }, [isActiveStep, isMounted])

  return (
    <Step
      index={index}
      trackingKey={ROLES.trackingKey}
      itemsCount={NEW_ROLES.choices.length}
      title={NEW_ROLES.question}
      subtitle='Select one (Required)'
    >
      {NEW_ROLES.choices.map(({ advanceTo, icon, text, value }) => (
        <SingleAnswer
          key={`${text}-${value}`}
          advanceTo={advanceTo}
          question={NEW_ROLES.question}
          surveyKey={NEW_ROLES.key}
          text={text}
          icon={icon}
          value={value}
        />
      ))}
    </Step>
  )
}
